const getSnackbars = (state) => state.snackbar.snackbarQueue;
export const SnackbarSelectors = {
    getSnackbars,
};
